<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Grid Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.layout.columns"
                  type="number"
                  label="Items per row (desktop)"
                  min="1"
                  max="6"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="fields.layout.gap"
                  type="number"
                  label="Gap"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
            </v-row>
            <p class="text-caption text--secondary mt-2 mb-0">Mobile always displays 1 item per row.</p>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Items ({{ fields.items.length }})</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion class="mt-2">
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`saintbrand-features-grid-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <div class="line-clamp-1" v-html="item.text.replace(/<[^>]*>/g, '').trim()"></div>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <label class="mb-2 d-block">Text</label>
                <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'saintbrand-features-grid-section-editor',
  components: {
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Saintbrand features grid',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        layout: {
          columns: 2,
          gap: 16,
        },
        items: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        layout: { ...this.fields.layout, ...(extract.layout || {}) },
        items: Array.isArray(extract.items) ? extract.items : this.fields.items,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSaintbrandFeaturesGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push({
        text: '<p>Feature text</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
